export const disableUserSelect = `
    -webkit-tap-highlight-color: transparent;
	cursor: default;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	&:focus{    
		outline: none !important;
	}
`;
export const fadeInTransition = `
	transition: 0.5s;
	-webkit-animation-name: fadeIn;
	animation-name: fadeIn;
	-webkit-animation-duration: 0.5s;
	animation-duration: 0.5s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
`;

export const growTransition = `
  transition: 0.3s;
  -webkit-animation-name: grow;
  animation-name: grow;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;

  @-webkit-keyframes grow {
    from {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    to {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  @keyframes grow {
    from {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    to {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
  }
`;
